import React from 'react';
import { Table } from 'react-bootstrap';

import { ReportInspectionPlanForOrganizationType } from '../../../common/types/ReportTypes';
import { ReportAlert } from '../Reports/ReportAlert';
import { ExportToExcel } from '../../../common/components/Excel/ExportToExcel';
import { FilterReportYearData } from '../Reports/Filter';

type Props = {
  data: ReportInspectionPlanForOrganizationType | undefined;
  reportName: string;
  filterApplied?: boolean;
  usedFilter?: FilterReportYearData;
};

export const ReportInspectionPlanByOrganization: React.FC<Props> = ({
  data,
  reportName,
  filterApplied,
  usedFilter,
}) => {
  const hasData = !data ? false : Object.keys(data?.details).length > 0;

  return (
    <>
      <ExportToExcel fileName={reportName} filter={usedFilter}>
        <Table id="table-to-export" striped bordered hover>
          <thead className="text-center">
            <tr>
              <th rowSpan={3}>Organ</th>
              <th colSpan={7}>{reportName}</th>
            </tr>
            <tr>
              <th colSpan={2}>kontrole planowe u podmiotów</th>
              <th colSpan={2}>% wykonania planu w zakresie kontroli</th>
              <th rowSpan={2}>kontrole doraźne (w tym rekontrole)</th>
              <th rowSpan={2}>ogółem kontrole (planowe i doraźne)</th>
            </tr>
            <tr>
              <th>ogółem</th>
              <th>w tym CPR</th>
              <th>ogółem</th>
              <th>w tym CPR</th>
            </tr>
          </thead>

          {hasData && (
            <tbody>
              {data &&
                hasData &&
                Object.keys(data?.details)
                  .sort((a, b) => a.localeCompare(b, 'pl'))
                  .map((key, idx) => (
                    <tr key={idx}>
                      <td>{key}</td>
                      <td className="numbers-column">
                        {data?.details?.[key]?.inspectionPlannedCount}
                      </td>
                      <td className="numbers-column">
                        {data?.details?.[key]?.inspectionPlannedCprCount}
                      </td>
                      <td className="percentage-column">
                        {data?.details?.[key]?.inspPlanProductCount > 0
                          ? (
                              (data?.details?.[key]?.inspectionPlannedCount /
                                data?.details?.[key]?.inspPlanProductCount) *
                              100
                            ).toFixed(2) + '%'
                          : ''}
                      </td>
                      <td className="percentage-column">
                        {data?.details?.[key]?.inspPlanProductCPRCount > 0
                          ? (
                              (data?.details?.[key]?.inspectionPlannedCprCount /
                                data?.details?.[key]?.inspPlanProductCPRCount) *
                              100
                            ).toFixed(2) + '%'
                          : ''}
                      </td>
                      <td className="numbers-column">
                        {data?.details?.[key]?.inspectionAdHocCount}
                      </td>
                      <td className="numbers-column">
                        {data?.details?.[key]?.inspectionAllCount}
                      </td>
                    </tr>
                  ))}
              <tr>
                <td>Suma:</td>
                <td className="numbers-column">
                  {data?.sum?.inspectionPlannedCount}
                </td>
                <td className="numbers-column">
                  {data?.sum?.inspectionPlannedCprCount}
                </td>
                <td className="percentage-column">
                  {data?.sum && data?.sum?.inspPlanProductCount > 0
                    ? (
                        (data?.sum?.inspectionPlannedCount /
                          data?.sum?.inspPlanProductCount) *
                        100
                      ).toFixed(2) + '%'
                    : ''}
                </td>
                <td className="percentage-column">
                  {data?.sum && data?.sum?.inspPlanProductCPRCount > 0
                    ? (
                        (data?.sum?.inspectionPlannedCprCount /
                          data?.sum?.inspPlanProductCPRCount) *
                        100
                      ).toFixed(2) + '%'
                    : ''}
                </td>
                <td className="numbers-column">
                  {data?.sum?.inspectionAdHocCount}
                </td>
                <td className="numbers-column">
                  {data?.sum?.inspectionAllCount}
                </td>
              </tr>
            </tbody>
          )}
        </Table>
        <ReportAlert hasData={hasData} filterApplied={filterApplied} />
      </ExportToExcel>
    </>
  );
};
